<template>
  <div class="termsWrap">
    <div class="content" v-html="text" />
  </div>
</template>

<script>
export default {
  name: "privacy",
  data() {
    return {
      text: `
<h3>《小库用户隐私协议》</h3>
<pre>
深圳小库科技有限公司（注册地址：深圳市南山区西丽街道西丽社区兴科路万科云城设计公社B2区-B210-1，以下简称“小库公司”）尊重您的个人信息权利，理解遵守合法、正当、必要和诚信原则处理您个人信息的重要性，并且深知您的信任对我们非常重要，我们将尽最大努力全力保护您的隐私。我们将遵循“合理、相关、必要”原则，且以您同意本协议或其他服务协议为前提收集信息，不会收集法律法规禁止收集的信息。如果您在本网站访问预定或使用小库的服务（以上统称为“服务”），便视为您/您的监护人接受了以下隐私协议。请您仔细阅读以下内容，如果您/您的监护人不同意以下任何内容，请立刻停止访问/使用本网站或其他任何移动应用或软件。本隐私协议中提及的“我们”指深圳小库科技有限公司及其关联方，“用户”以及“您”均指自愿接受本隐私协议的用户。 

本协议将帮助您了解以下内容：
一、定义、声明及适用范围
二、个人信息的收集和使用
三、个人信息的共享、转让、公开披露等
四、Cookie和同类技术的使用
五、信息安全
六、个人信息存储
七、个人信息管理
八、未成年人须知
九、修订和通知
十、适用范围
十一、联系我们

一、定义、声明及适用范围
（一）定义
1、小库服务提供者：是指研发并提供小库产品及服务的法律主体，即深圳小库科技有限公司及其关联方。
2、支付公司：指提供支付功能服务的主体，包括支付宝（中国）网络技术有限公司。
3、小库企业/组织用户：指通过企业或其他组织授权管理员或直接通过法定代表人注册成为小库用户，并以企业/组织账号使用人身份代表企业/组织开通、管理和使用小库服务的企业或组织用户。小库企业/组织用户包括但不限于法人、政府机构、合伙企业、个体工商户或其他组织等。
4、小库个人用户：是指注册小库账户的个人用户。
5、个人信息的定义与范围
5.1 个人信息，是指以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息，不包括匿名化处理后的信息。在本隐私协议中包括但不限于：姓名、手机号码、用户密码或者其他身份证明、电子邮箱、紧急联系人、订单收件人联系信息、订单信息及交易状态、支付信息、提现记录、日志信息、设备信息、IP地址、购买记录（详见附件一：收集个人信息明示清单）。 
5.2 小库公司认为，为了您的合法利益，或者公共利益/国家利益，或者法律法规规定的应当取得个人信息保护及本协议第5.1条之外的个人信息时，您同意小库公司有权届时获取相关信息。 
5.3 个人敏感信息，是指一旦泄露、非法提供或滥用则可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，在本隐私协议中包括：姓名、手机号码、支付信息、银行卡号。 
5.4 匿名化处理后的信息，即通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后不能被复原的信息。匿名化处理后的信息不属于个人信息。 
5.5 其他无法识别特定自然人身份或者反映特定自然人活动情况的信息不属于个人信息。 
5.6 个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使被删除的个人信息保持不可被检索、访问的状态。
5.7 个人信息处理者：有权决定个人信息处理目的、方式等的组织或个人。
6、除另有约定外，本政策所用定义与《小库注册用户协议》中的定义具有相同的含义。
（二）声明
1、<b>请您确认，如果您未满18周岁，请在监护人陪同下阅读、同意接受本协议并申请开通相关功能。但如您未满14周岁，应立即停止申请使用本服务。</b>
2、我们将在本协议中依次向您说明每项功能可能收集的个人信息的范围、收集目的、收集方式以及拒绝提供个人信息可能导致的结果。<b>请您知悉，当您拒绝提供各项功能实现所必要的对应信息时，将无法继续使用小库的任何功能。</b>
3、本协议将向您说明小库可能需要调取的设备权限、调用的目的或其对应的业务功能、调用前是否询问以及用户关闭相应权限的方式。<b>请知悉，您同意本协议后，相应设备权限并不会默认开启，当涉及重要或敏感的设备权限时，我们会在您使用到相应业务功能时，另行弹窗再次征得您的同意后开启。权限开启后，您还可以随时通过设备设置权限关闭。若您不同意开启权限，将不会影响其他非相关业务功能的正常使用。</b>
4、<b>请您注意，当您在使用小库过程中出于业务需求，向我们提供除您本人外其他任何人的个人信息时，您应当确保我们在处理这些个人信息前，您已经获得了相关个人信息主体的同意。</b>
（三）适用范围
本政策适用于小库自营的产品及服务，包括小库（https://www.xkool.ai）、小库子站以及将小库部分功能/服务作为第三方服务集成在第三方智能硬件、软件或服务中（统称“小库服务”，具体以小库服务提供者提供的服务为准）。

二、个人信息的收集与使用
（一）直接收集与使用的个人信息
我们会在如下场景和业务活动中收集您在使用小库及相关服务时主动提供的用户信息，以及我们通过自动化手段收集您在使用小库及相关服务过程中产生的用户信息，包括但不限于用户向平台提供的个人信息。
<b>特别提示您注意，如用户信息无法单独或结合其他信息识别到您的个人身份且与您无关，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份或与您有关，或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，则在结合使用期间，这些信息将作为您的个人信息按照本隐私协议处理与保护。需要澄清的是，个人信息不包括经匿名化处理后的信息。</b>
1、注册、认证、登录平台账号时
您使用小库服务，需要登录经注册的平台账号。当您在小库注册账号时，您可以通过手机号、设置用户名及密码创建账号。我们将通过发送短信验证码来验证您的身份是否有效，收集这些信息是为了帮助您完成注册。如果您使用其他平台的账号登录小库或将其他平台账号与小库账号进行关联、绑定，您将授权小库公司获得您其他平台账号的相关信息，例如微信、QQ、知乎、领英、微博等第三方平台的账户/账号信息或其他第三方平台注册的公开信息（包括但不限于名称、头像、封面、简介以及您授权的其他信息）。
2、订购及开通使用小库提供服务时
2.1 如果您是个人用户，您可能需要提供您的身份信息，包括手机号码、电子邮箱等。
2.2 如果您是小库企业/组织用户，您可能需要提供您的用户信息，包括您的主体名称、统一社会信用代码、就注册平台账号所出具的授权委托书（加盖公章且经法定代表人签字确认）等。另外，您可能需要提供企业联系人的个人信息，包括手机号码、电子邮箱。如您提供的上述信息包含第三方的个人信息，您承诺并保证您向我们提供这些信息前已经获得了相关权利人的授权许可。
3、您使用小库及相关服务时
3.1 我们致力于为您提供安全、可信的产品与使用环境，优质、可靠的服务与信息。为了维护我们服务的正常运行，保护您或其他用户或公众的合法利益免受损失，我们会收集用于维护产品或服务安全稳定运行的必要信息。
3.2 当您浏览或使用小库时，为了保障网站和服务的正常运行及运营安全，我们会收集您的硬件型号、操作系统类型及操作系统版本号、网络设备硬件地址（MAC）、IP地址、软件版本号、浏览器类型及浏览器版本、分辨率、时区和语言、网络接入方式及类型信息。请您了解，这些信息是我们提供服务和保障服务正常运行和网络安全所必须收集的基本信息。
3.3 为让您体验到更好的服务，并保障您的使用安全，我们可能记录网络日志信息，以及使用平台及相关服务的频率、崩溃数据、使用情况及相关性能数据信息。
3.4 当您通过小库发布或提交文字、图片、讯息、评论或任何其他内容（“发布内容”）时，平台会留存您的名称、头像和发布内容。
3.5 <b>为提升用户使用服务的体验，我们可能会将您在小库上传的内容（包括但不限于图片等）进行分析或作为AI训练使用，小库公司承诺将对上传内容中的个人信息（如有）进行匿名化处理。未经您的明确授权，不会用作其他目的。</b>
3.6 我们可能收集您使用小库及相关服务而产生的用户咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），我们将记录、分析这些信息以便更及时响应您的帮助请求，以及用于改进服务。
3.7 合同信息，如果您需要申请线下交付或进行产品测试等，为履行合同所必需，您应提供联系人、联系方式、地址、开票信息、订单等必要信息。
3.8 <b>您知悉并同意，对于您在使用产品及/或服务的过程中提供的您的联系方式（即手机号码及电子邮箱），我们在运营中可能会向其中的一种或多种发送通知，用于用户消息告知、安全验证、用户使用体验调研等用途；此外，我们也可能会向在前述过程中收集的手机号码及电子邮箱通过短信、电话、电子邮件的方式，为您提供您可能感兴趣的服务、功能或活动等商业性信息，但请您放心，如您不愿接受这些信息，您可以通过手机短信或电子邮件中提供的退订方式进行退订，也可以直接与我们联系进行退订。</b>
我们将信息用于本协议未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
在以上场景中可能涉及收集相关个人的敏感个人信息，收集此类信息的目的包括满足相关法律法规的要求进行网络实名认证、核验您的用户身份。
（二）我们可能从第三方获得的个人信息
为了给您提供更好、更优、更加个性化的服务，或共同为您提供服务，或为了预防互联网欺诈的目的，我们的关联公司、合作伙伴会依据法律规定或与您的约定或在征得您同意前提下，向我们分享您的个人信息。我们会根据相关法律法规规定和/或该身份认证功能所必需，采用行业内通行的方式及尽最大的商业努力来保护您个人信息的安全。
（三）收集、使用个人信息目的变更的处理
<b>请您了解，随着我们业务的发展，可能会对小库产品网站的功能和提供的服务有所调整变化。当新功能或服务需要收集、使用我们已收集的您的个人信息时，我们在收集、使用该信息前会再次向您说明信息收集、使用的范围和目的，并征得您的同意。</b>
（四）业务和客户数据
请您理解，您的业务和客户数据不同于个人信息，<b>小库产品网站</b>将按如下方式处理：
1、您通过<b>小库产品网站</b>提供的服务（不包括第三方服务）进行加工、存储、上传、下载、分发以及通过其他方式处理（以下简称“处理”）的数据，均为您的业务和客户数据。
2、<b>您应对您的业务和客户数据来源及内容负责，我们提示您谨慎判断数据来源及内容的合法性。您应保证您有权使用官网及服务对该等数据进行处理，且前述处理活动均符合相关法律法规的要求，不存在任何违法违规、侵权或违反与第三方合同约定的情形，亦不会将数据用于违法违规目的，因您的业务和客户数据内容及您的数据处理行为违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。</b>
3、受限于第二条个人信息的收集与使用的规定，对于<b>小库产品网站</b>自用户处获取的包括业务和客户数据在内的任何数据中的个人信息，您应当依法提前向相关个人信息主体履行告知义务，并取得相关个人信息主体的单独同意，并保证：
3.1 根据我们要求的方式，就个人信息来源及其合法性提供书面说明和确认；
3.2 在我们要求时，提供个人信息处理的授权同意范围，包括使用目的及个人信息主体同意您使用<b>小库产品网站</b>对其个人信息进行处理；
3.3 如您使用<b>小库产品网站</b>及相关服务所需进行的个人信息处理活动超出该个人信息的授权同意范围的，应在提供个人信息后的合理期限内或在我们处理个人信息前，由您负责征得个人信息主体的明示同意并在我们要求时向我们提供书面证明。
<b>您理解并同意，除非满足上述条件及法律要求的其他义务，您不得向我们提供包含个人信息的业务和客户数据。如您违反上述义务，或未按照要求向我们提供合理、满意的证明，或我们收到个人信息主体举报或投诉，我们有权单方决定拒绝传输您的相关数据（根据实际情形，包括通过限制相关服务功能，冻结、注销或收回账号等方式），或拒绝按照您的指令处理相关个人信息及相关的数据，由此产生的全部责任均由您自行承担。</b>
3.4 <b>您理解并同意，您应根据自身需求自行对您的业务和客户数据进行存储，我们仅依据相关法律法规要求或特定服务规则的约定，提供数据存储服务（例如，就数据存储业务，在您和我们约定的境内数据中心存储您的业务和客户数据）。但您理解并同意，除非法律法规另有规定或依据服务规则约定，我们没有义务存储您的数据或信息，亦不对您的数据存储工作或结果承担任何责任。</b>

三、个人信息的共享、转让和公开披露
（一）数据使用过程中涉及的合作方
1、原则
  1.1 合法原则：与合作方合作过程中涉及数据使用活动的，必须具有合法目的、符合法定的合法性基础。如果合作方使用信息不再符合合法原则，则其不应再使用您的个人信息，或在获得相应合法性基础后再行使用。
  1.2 正当与最小必要原则：数据使用必须具有正当目的，且应以达成目的必要为限。
  1.3 安全审慎原则：我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。
2、委托处理
对于委托处理个人信息的场景，我们会与受托合作方根据法律规定签署相关处理协议，并对其个人信息使用活动进行监督。
3、共同处理
对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。
4、合作方的范围
若具体功能和场景中涉及由我们的第三方提供服务，则合作方范围包括第三方。
5.合作方式
第三方SDK情况说明：
为保障我们产品的稳定运行、功能实现，使您能够享受和使用更多的服务及功能，我们的产品会在必要情况下使用第三方SDK（软件开发工具包），详见附件二:《第三方SDK明细》。第三方SDK存在因其版本更新、政策调整而导致获取用户的信息发生变化，具体请以该SDK官网说明为准。
（二）个人信息共同数据处理或数据委托处理的情形
1、官网及相关服务功能中的某些具体模块或功能由外部供应商提供，对此您理解并同意。对我们委托处理个人信息的公司、组织和个人，我们会与其签署保密协议，要求其按照我们的要求、本隐私协议以及其他相关的保密和安全措施来处理个人信息。
  1.1 支付功能:支付功能由我们合作的第三方支付机构向您提供服务，请您仔细阅读并遵守第三方支付机构的用户隐私保护协议。
  1.2 客户服务:为及时处理您的投诉、建议以及其他诉求，客户服务提供商需要使用您的账号及所涉及的事件的相关信息，以及时了解、处理相关问题。
2、为保障服务安全与分析统计的数据使用
  2.1 保障服务安全：我们非常重视账号与服务安全，为保障您和其他用户的账号与财产安全，使您和我们的正当合法权益免受不法侵害，我们和我们的合作方需要使用必要的设备、账号及日志信息。
  2.2 分析统计的数据：为分析我们服务的使用情况，提升用户使用的体验，我们和我们的合作方需要使用您的服务使用情况（崩溃、闪退）的统计性数据，这些数据通常不会与其他信息结合识别您的身份或与您的身份相关联。
（三）个人信息的转移
我们不会转移您的个人信息给任何其他第三方，但以下情形除外：
1、基于您的书面请求，并符合国家网信部门规定条件的，我们会向您提供转移的途径。
2、获得您的明确同意后，我们会向其他第三方转移您的个人信息。
3、在涉及平台运营主体变更、合并、收购或破产清算时，如涉及到个人信息转移，我们会依法向您告知有关情况，并要求新的持有您信息的公司、组织继续接受本隐私协议的约束或按照不低于本隐私协议所要求的安全标准继续保护您的信息，否则我们将要求该公司、组织重新向您征求授权同意。<b>如平台运营主体进行注销且无数据承接方的，我们将对您的信息做删除处理。</b>
（四）个人信息的公开披露
1、原则上我们不会公开披露您的个人信息，除非获得您明确同意或遵循国家法律法规规定。
  1.1 获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
  1.2 为保护小库用户或公众的人身、财产安全免遭侵害，我们可能根据相应的法律或小库相关协议、规则披露关于您的个人信息。
2、依法豁免征得同意提供、公开的个人信息
请您理解，在下列情形中，传输、转移、提供、公开您的个人信息无需征得您的授权同意：
  2.1 为履行法定职责或者法定义务所必需；
  2.2 与国家安全、国防安全直接相关的；
  2.3 与刑事侦查、起诉、审判和判决执行等直接相关的；
  2.4 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
  2.5 为公共利益实施新闻报道、舆论监督等行为，在合理范围内处理个人信息；
  2.6 依照相关法律规定处理您自行公开或者其他已经合法公开的个人信息；
  2.7 从合法公开披露的信息中收集个人信息的；
  2.8 法律、行政法规规定的其他情形。
四、Cookie和同类技术的使用
Cookie和同类技术是互联网中的通用常用技术。当您使用小库产品网站时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您的账号信息、搜索记录信息以及登录状态信息。通过Cookie和同类技术可以帮助您省去重复填写账号信息、输入搜索内容的步骤和流程，还可以帮助我们改进服务效率、提升登录和响应速度。
您可以通过浏览器设置拒绝或管理Cookie。但请注意，如果停用Cookie，您有可能无法享受最佳的服务体验，某些功能的可用性可能会受到影响。我们承诺，我们不会将通过Cookie或同类技术收集到的您的个人信息用于本隐私协议所述目的之外的任何其他用途。
五、信息安全
（一）我们非常重视用户信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的信息，防止您提供的信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。
（二）我们会使用不低于行业通行的加密技术、匿名化处理等合理可行的手段保护您的信息，并使用安全保护机制尽可能地降低您的信息遭到恶意攻击的可能性。
（三）我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的信息，并根据公司相关内部管理制度适时对数据和技术进行安全审计。
（四）尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的信息的安全性。<b>您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护用户信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等信息透露给他人。</b>
（五）我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止该等安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函或短信等形式告知您。难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。
（六）我们谨此特别提醒您，本隐私协议提供的用户信息保护措施仅适用于小库的产品网站及相关服务。一旦您离开小库产品网站及相关服务，浏览或使用其他网站、产品、服务及内容资源，无论是否基于小库产品网站的链接或引导，我们没有能力及义务保护您在小库产品网站及相关服务之外的软件、网站提交的任何信息的安全性。

六、个人信息存储
（一）信息存储的地点
我们依照法律法规的规定，将在境内运营本网站和相关服务过程中收集和产生的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，日后如果我们向境外传输，我们将会遵循国家相关规定，征求您的授权同意。
（二）存储期限
1、我们将仅在为提供小库产品网站及相关服务之目的所必需的期间内保留您的个人信息，但您理解并认可基于不同的服务及其功能需求，必要存储期限可能会有所不同。我们用于确定存储期限的标准包括：完成该业务目的需要留存个人信息的时间，包括提供服务，依据法律要求维护相应的交易及业务记录，保证系统和服务的安全，应对可能的用户查询或投诉、问题定位等；用户是否同意更长的留存期间；法律、合同等是否有保留个人信息的特殊要求等。
2、在您未撤回授权同意、删除或注销账号期间，我们会保留相关信息。超出必要期限后，我们将对您的信息进行删除或匿名化处理，但法律法规另有规定的除外。
七、个人信息管理
我们非常重视对个人信息的管理，并依法保护您对于您信息的查阅、复制、更正、补充、删除以及撤回授权同意、注销账号、投诉举报等权利，以使您有能力保障您的隐私和信息安全。
（一）您在个人信息处理活动中的权利
1、当您完成官网的账号注册、登录并进行合理且必要的身份验证后，您可以发送邮件至“mo@xkool.org”或拨打热线 “400 807 1991”联系我们查阅、复制、更正、补充、删除您提交给官网及相关服务的个人信息。
2、一般情况下，您可以查阅、复制、更正、补充、访问、修改、删除您主动提供的个人信息。出于安全性和身份识别的考虑，您可能无法自主更正注册时提交的某些初始注册信息；如您确有必要更正该类信息，请您发送邮件至“mo@xkool.org”或拨打热线 “400 807 1991”联系我们，我们将尽快审核所涉问题，并由专人验证您的用户身份后及时予以回复。
3、在以下情形中，您可以向我们提出删除个人信息的请求：
3.1 如果处理目的已实现、无法实现或者为实现处理目的不再必要；
3.2 如果我们处理个人信息的行为违反法律法规；
3.3 如果我们收集、使用您的个人信息，却未征得您的同意；
3.4 如果我们处理个人信息的行为违反了与您的约定；
3.5 如果我们停止提供产品或者服务，或个人信息的保存期限已届满；
3.6 如果您撤回同意；
3.7 如果我们不再为您提供服务；
3.8 法律、行政法规规定的其他情形。
（二）注销您的账号
<b>您知悉并理解，注销账号的行为是不可逆的行为，当您注销账号后，我们将停止为您提供任何服务，并删除有关您账号的一切信息或对相关信息进行匿名化处理，因法律法规规定需要留存个人信息的，我们承诺将其单独存储，并不会将该等信息用于日常业务活动中。</b>
（三）撤回或改变您授权同意的范围
1、<b>您理解并同意，每项服务均需要一些基本个人信息方得以完成。除为实现业务功能收集的基本个人信息外，对于额外的个人信息的收集和使用，您可以选择撤回您的授权，或改变您的授权范围。您也可以通过注销账号的方式，撤回我们继续收集您个人信息的全部授权。</b>
2、<b>您理解并同意，当您撤回同意或授权后，将无法继续使用与撤回的同意或授权所对应的服务，且官网也不再处理您相应的个人信息，并删除有关您账号的一切信息或对相关信息进行匿名化处理。</b>
3、如果您不想接收我们给您发送的商业广告，您可随时发送邮件至“mo@xkool.org”或拨打热线 “400 807 1991”联系我们取消。
（四）如何获取您的个人信息副本
我们将根据您的书面请求，为您提供以下类型的个人信息副本：您的基本资料、用户身份信息。但请注意，我们为您提供的信息副本仅以我们直接收集的信息为限。
（五）约束信息系统自动决策
在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权发送邮件至“mo@xkool.org”或拨打热线 “400 807 1991”联系我们做出解释，我们也将视实际情况向您提供适当的救济方式，如对自主决策结果进行人工复核或终止使用自动决策机制作出相关决定。
（六）投诉举报
您可以按照我们公示的制度进行投诉或举报。如果您认为您的信息权利可能受到侵害，或者发现侵害您信息权利的线索，您可以发送邮件至“mo@xkool.org”或拨打热线 “400 807 1991”提交相关信息和权利证明材料来与我们联系。我们核查后会及时反馈您的投诉与举报。
（七）响应您的上述请求
为保障安全，您可能需要提供书面请求，并以其它方式证明您的身份。我们可能会先要求您根据《小库注册用户协议》及相关规则验证身份，然后再处理您的请求。如您对答复不满意，还可以通过上述途径投诉举报。
对于您合理的请求，我们原则上不收取费用。但对多次重复、超出合理限度的请求，我们将视具体情形收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
您理解并认可，在以下情形中，我们将无法响应您的请求：
1、与我们履行法律法规规定的义务相关的；
2、与国家安全、国防安全直接相关的；
3、与公共安全、公共卫生、重大公共利益直接相关的；
4、与刑事侦查、起诉、审判和执行判决等直接相关的；
5、我们有充分证据表明个人信息主体存在主观恶意或滥用权利的；
6、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
7、响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；
8、涉及商业秘密的。
（八）停止运营向您告知
如我们停止运营，我们将停止收集您的个人信息，并将停止运营的通知以逐一送达或公告等商业上可行的形式通知您，并对我们所持有的您的个人信息进行删除或匿名化处理。
八、未成年人需知
<b>我们的服务主要面向企业或相关组织。如果没有父母或监护人的同意，未成年人不应创建任何账户或使用小库产品网站及其服务。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。</b>
九、修订和通知
（一）为了给您提供更好的服务，官网及相关服务将不时更新与变化，我们会适时对本隐私协议进行修订，该等修订构成本隐私协议的一部分并具有等同于本隐私协议的效力。但未经您明确同意，我们不会削减您依据当前生效的隐私协议所应享受的权利。
（二）本隐私协议更新后，我们会在官网公布更新版本，并在更新后的条款生效前以适当的方式提醒您更新的内容，以便您及时了解本隐私协议的最新版本。如您继续使用官网及相关服务，视为您同意接受修订后的本隐私协议的全部内容。
（三）对于重大变更，我们还会提供更为显著的通知（包括但不限于电子邮件、短信、系统消息或在浏览页面做特别提示等方式），向您说明本隐私协议的具体变更。
本隐私协议所指的重大变更包括但不限于：
1、我们的服务模式发生重大变化，如处理个人信息的目的、处理个人信息的类型、个人信息的使用方式等；
2、我们的生产经营发生重大变化且公司可能被吊销营业执照、破产、清算；
3、个人信息传输、转移或公开披露的主要对象发生变化；
4、您参与个人信息处理方面的权利及其行使方式发生重大变化；
5、我们的联络方式及投诉渠道发生变化时。
十、适用范围
1、本隐私协议适用于小库产品网站提供的产品、服务、解决方案以及公司后续可能不时推出的纳入服务范畴内的其他产品、服务或解决方案。
2、本隐私协议不适用于有单独的隐私协议且未纳入本隐私协议的第三方通过官网向您提供的产品或服务（“第三方服务”）。您使用这些第三方服务（包括您向这些第三方提供的任何含个人信息在内的信息），将受这些第三方的服务条款及隐私协议约束（而非本隐私协议），并通过其建立的个人信息主体请求和投诉等机制，提出相关请求、投诉举报，具体规定请您仔细阅读第三方的条款。请您妥善保护自己的个人信息，仅在必要的情况下向第三方提供。
3、需要特别说明的是，作为小库产品网站的用户，若您利用小库产品网站的技术服务，为您的用户再行提供服务，因您的业务和客户数据属于您所有，您应当与您的用户自行约定隐私协议，本隐私协议不作为您与您的用户之间的隐私协议的替代。
4、如果您实际订购的产品或服务超出了本隐私协议的范围，则对收集和处理该信息的用途和方式将会在产品或服务的说明界面进行告知并征得同意。
十一、联系我们
如对本隐私协议内容有任何疑问、意见或建议，您可发送邮件至 “mo@xkool.org”或拨打热线 “400 807 1991”与我们联系。一般情况下，我们将在15日内予以回复（“回复期”），但您理解并同意，结合您请求的复杂度，前述回复期可能延迟至30日，但我们会在回复期届满前向您书面告知延迟原因。
更新日期：2021年12月6日

附件一：收集个人信息明示清单
序号	收集的个人信息	收集方式	收集目的
1	用户名称 	用户填写	用于为用户创建账号并提供服务
2	用户所在机构名称 	用户填写	
3	邮箱	用户填写	
4	手机号 	用户填写	
5	最新登录ip 	主动采集或记录	优化用户体验
6	最新登录时间	主动采集或记录	优化用户体验
7	登录总次数 	主动采集或记录	优化用户体验
8	在线时长 	主动采集或记录	优化用户体验
9	账号创建时间  	主动采集或记录	优化用户体验
10	账号上次更新时间  	主动采集或记录	优化用户体验
11	企业账号名称 	用户填写	优化用户体验
12	创建企业账号的用户id  	主动采集或记录	优化用户体验
13	企业账号创建时间 	主动采集或记录	优化用户体验
14	企业账号上次更新时间 	主动采集或记录	优化用户体验
15	使用第三方账号注册登录的，授权信息包括:用户名称、头像性别、地理位置等公开信息	主动采集或记录	提供服务必须的信息
16	收集用户主动上传的CAD文档，DAE模型文档，图片等，包括解析其文档类型，大小等	主动采集或记录	提供服务必须的信息，设计云不做任何他用
17	设备信息：唯一设备识别号UUID、GUID等、品牌、型号、系统类型系统版本、分辨率、设备地址;设备连接信息:浏览器类型、运营商类型网络;位置信息:IP地址;用户操作行为数据:用户使用产品频率，功能使用等	主动采集或记录	为优化用户体验，由设计云进行收集
18	支付信息:在用户使用支付宝、微信等支付机构的支付通道时，我们要收集:订单号、交易金额、内容等，如果有发票，还包括:发票抬头、纳税人识别号、收票人地址等购方信息	主动采集或记录	为用户开具相应电子发票
19	Cookie使用	主动采集或记录	优化用户体验
20	与其他用户在系统内的交互关系，如分享转发、查看等	主动采集或记录	用于将来可能出现的推荐场景;针对用户综合活跃度（活跃+行为）统计，用于将来可能出现的优先推荐、互动的数据基础
21	在小库生态内的其他整体行为汇总，如是否参加发布会，是否添加企微、是否付费等	主动采集或记录	用于综合评价用户粘度和购买潜力

附件二：《第三方SDK明细》
序号	SDK名称	公司名称	使用目的	涉及个人信息	第三方隐私协议链接
1	高德地图	高德软件有限公司	提供地图显示及定位服务	定位权限、网络访问权限	https://lbs.amap.com/pages/privacy/
2	百度地图	百度控股有限公司	提供地图显示及定位服务	定位权限、网络访问权限	http://privacy.baidu.com/policy
3	微信	腾讯科技（深圳）有限公司	提供一键登录服务；可帮助用户完成付款，提供安全认证服务	设备识别信息、地理位置	https://privacy.qq.com/
4	支付宝	支付宝（中国）网络技术有限公司	可帮助用户完成付款，提供安全认证服务	设备识别信息	https://render.alipay.com/p/c/k2cx0tg8
</pre>`,
    };
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
